export default __webpack_public_path__ + "static/media/Asset 2.491b9991.jpg";